import React from 'react';
import css from './GridItem.module.css'
type GridItemProps = {
  col: number; // 1-24
  height?: number; // px
  rowSpan?: number; // добавлено
  className?: string;
  children: React.ReactNode;
};

export const GridItem: React.FC<GridItemProps> = ({ col, height, rowSpan, className, children }) => (
  <div
    className={css.gridItem}
    style={{
      gridColumn: `span ${col}`,
      gridRowEnd: rowSpan ? `span ${rowSpan}` : undefined,
      height: height ? `${height}px` : undefined,
    }}
  >
    {children}
  </div>
); 